export default __webpack_public_path__ + "static/media/qiuiz_result_background.e826da4f.png";